// extracted by mini-css-extract-plugin
export default {"iconBtn":"HeadToHeadStatsButton_iconBtn__SCJyO","textBtn":"HeadToHeadStatsButton_textBtn__ywG6X"};